// export const api_url = "http://localhost:2000"
export const api_url = "https://apiv1.rxultimate.com"


export const modulePermissions = [
    {
        "module":{
            "id":1,
            "name":"Inventory"
        },
        "permissions":[
            {
                "id":1,
                "name":"Manage"
            },
            {
                "id":2,
                "name":"Create"
            },
            {
                "id":3,
                "name":"Edit"
            },
            {
                "id":4,
                "name":"Delete"
            },
        ]
    },
    {
        "module":{
            "id":2,
            "name":"Sales"
        },
        "permissions":[
            {
                "id":5,
                "name":"Manage"
            },
            {
                "id":6,
                "name":"Create"
            },
            {
                "id":7,
                "name":"Edit"
            },
            {
                "id":8,
                "name":"Delete"
            },
        ]
    },
]